/** Kullanıcı rolleri — backend enum ile uyumlu; `sales` arayüzde Müşteri Hizmetleri */

export const USER_ROLE_LABELS = {
  superadmin: 'Süper Admin',
  admin: 'Admin',
  mod: 'Moderator',
  sales: 'Müşteri Hizmetleri',
  sevkiyat: 'Sevkiyat',
  'tech-service': 'Teknik Servis',
  'tech-person': 'Teknisyen',
  bayi: 'Bayi',
  'review-app': 'Review App',
};

/** Kullanıcı yönetimi formları / filtreler */
export const USER_ROLE_OPTIONS = [
  { value: 'admin', label: 'Admin', color: '#dc2626' },
  { value: 'mod', label: 'Moderator', color: '#9333ea' },
  { value: 'sales', label: 'Müşteri Hizmetleri', color: '#1e3a8a' },
  { value: 'sevkiyat', label: 'Sevkiyat', color: '#0d9488' },
  { value: 'tech-service', label: 'Teknik Servis', color: '#3b82f6' },
  { value: 'tech-person', label: 'Teknisyen', color: '#6b7280' },
  { value: 'bayi', label: 'Bayi', color: '#059669' },
  { value: 'review-app', label: 'Review App', color: '#b45309' },
];

export const getUserRoleLabel = (rol) => {
  if (!rol) return '';
  const key = String(rol).toLowerCase();
  return USER_ROLE_LABELS[key] || String(rol);
};
